const initialState = {
  focusList: [],
};

const reduceFocusList = (data) => {
  let uncompleted = data
    .filter((focus) => focus.completed === false || focus.completed === null)
    .sort((a, b) => {
      return b.updatedAt < a.updatedAt ? 1 : -1;
    });
  let completed = data
    .filter((focus) => focus.completed === true)
    .sort((a, b) => {
      return a.updatedAt < b.updatedAt ? 1 : -1;
    });
  return [...uncompleted, ...completed];
};

const focus = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_FOCUS_LIST": {
      let result = reduceFocusList(action.payload);
      return {
        ...state,
        focusList: result,
      };
    }
    case "CREATE_FOCUS": {
      const newFocus = action.payload;
      let data = [newFocus].concat(state.focusList).sort((a, b) => {
        return a.updatedAt < b.updatedAt ? 1 : -1;
      });
      let result = reduceFocusList(data);
      return {
        ...state,
        focusList: result,
      };
    }
    case "EDIT_FOCUS": {
      let focusWithoutEdited = state.focusList.filter(
        (n) => n.id !== action.payload.id
      );
      return {
        ...state,
        focusList: reduceFocusList([...focusWithoutEdited, action.payload]),
      };
    }
    case "MARK_FOCUS": {
      let indexMarked = state.focusList.findIndex(
        (n) => n.id === action.payload.id
      );
      let result = [...state.focusList];
      result[indexMarked].completed = !state.focusList[indexMarked].completed;
      let sorted = [...result].sort((a, b) => {
        return a.updatedAt < b.updatedAt ? 1 : -1;
      });
      return {
        ...state,
        focusList: reduceFocusList(sorted),
      };
    }
    case "DELETE_FOCUS": {
      let deletedList = state.focusList.filter(
        (x) => action.payload.focusId !== x.id
      );
      return {
        ...state,
        focusList: [...deletedList],
      };
    }
    default:
      return state;
  }
};

export default focus;
